<app-simple-modal [title]="'Top de Proveedores'" [requiredFields]="false" [max]="50" (close)="close.emit($event)">
	<div fields>
		<div class="card" *ngIf="provider">
			<h3 style="text-align: center;"><b>#1</b><i class="fa fa-star text-warning"></i>{{provider.vendorName}}</h3>
			<p style="margin-top: 0; margin-bottom: 0; text-align: center;">NIT: <b>{{provider.vendorNIT}}</b></p>
			<div class="row row-custom">
				<div class="col">
					<h4>{{provider.documentsCount}}</h4>
					<p class="text-muted">Cantidad de Documentos</p>
				</div>
				<div class="col">
					<h4>{{provider.documentsTotal | currency: 'Q'}}</h4>
					<p class="text-muted">Total de Compras</p>
				</div>
			</div>
		</div>
		<div class="table-responsive">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th>#</th>
						<th>Nombre</th>
						<th>NIT</th>
						<th>Documentos</th>
						<th>Total de Compras</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let provider of providers; let i = index">
						<td>
							{{i + 2}}
						</td>
						<td>
							{{provider.vendorName}}
						</td>
						<td>
							{{provider.vendorNIT}}
						</td>
						<td>
							{{provider.documentsCount}}
						</td>
						<td>
							{{provider.documentsTotal | currency: 'Q'}}
						</td>
					</tr>
					<tr class="tr-middle" *ngIf="providers.length == 0 && provider && !loading">
						<td colspan="5">
							<span class="text-muted"><i class="fa fa-circle-info"></i>
								No se cuenta con otros proveedores</span>
						</td>
					</tr>
					<tr class="tr-middle" *ngIf="providers.length == 0 && !provider && !loading">
						<td colspan="5">
							<span class="text-muted"><i class="fa fa-circle-info"></i>
								No se tienen proveedores</span>
						</td>
					</tr>
					<tr class="tr-middle" *ngIf="loading">
						<td style="padding: 2em;" colspan="5">
							<div class="d-flex align-items-center">
								<strong role="status">Cargando...</strong>
								<div class="spinner-border ms-auto" aria-hidden="true"></div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</app-simple-modal>